module.exports = __webpack_public_path__ + "img/logo_o.26564c1e.png";